import { render, staticRenderFns } from "./Provider.vue?vue&type=template&id=45a34a65&lang=pug&"
import script from "./Provider.vue?vue&type=script&lang=js&"
export * from "./Provider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports